// @mui
import { Container, Typography } from '@mui/material';
import { m } from 'framer-motion';

// assets
import { ForbiddenIllustration } from '../assets/illustrations';
// components
import { MotionContainer, varBounce } from '../components/animate';
//
import { useAuthContext } from './useAuthContext';

// ----------------------------------------------------------------------

type RoleBasedGuardProp = {
  children: React.ReactNode;
  hasContent?: boolean;
  roles?: string[];
};

const RoleBasedGuard = ({
  children,
  hasContent,
  roles,
}: RoleBasedGuardProp) => {
  // Logic here to get current user role
  const { user } = useAuthContext();

  // const currentRole = 'user';
  const currentRole = user?.role; // admin;

  if (typeof roles !== 'undefined' && !roles.includes(currentRole)) {
    return hasContent ? (
      <Container component={MotionContainer} sx={{ textAlign: 'center' }}>
        <m.div variants={varBounce().in}>
          <Typography paragraph variant="h3">
            Permission Denied
          </Typography>
        </m.div>

        <m.div variants={varBounce().in}>
          <Typography sx={{ color: 'text.secondary' }}>
            You do not have permission to access this page
          </Typography>
        </m.div>

        <m.div variants={varBounce().in}>
          <ForbiddenIllustration sx={{ height: 260, my: { sm: 10, xs: 5 } }} />
        </m.div>
      </Container>
    ) : null;
  }

  return <> {children} </>;
};

export default RoleBasedGuard;
